var _path, _path2, _g, _rect, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 44C149.352 44 155.001 84.6854 155 122C154.999 155.315 129.534 164 91 164C53.5387 164 25 155.315 25 122C25 84.6854 32.6484 44 91 44Z",
    fill: "black",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_45",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 44C149.352 44 155.001 84.6854 155 122C154.999 155.315 129.534 164 91 164C53.5387 164 25 155.315 25 122C25 84.6854 32.6484 44 91 44Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 42,
    width: 138,
    height: 124,
    fill: "#EEEEEE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 76C125.747 76 140.001 93.4742 140 107C139.999 120.526 120.411 124 91 124C61.9528 124 40 120.526 40 107C40 93.4742 55.1142 76 91 76Z",
    fill: "black",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8177 110.654C60.291 109.3 55.5831 104.312 56.3024 99.513C57.0217 94.7139 62.8957 91.9211 69.4224 93.275C75.9492 94.629 80.657 99.617 79.9378 104.416C79.2185 109.215 73.3444 112.008 66.8177 110.654Z",
    fill: "#25A6F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.422 110.654C106.896 112.008 101.022 109.215 100.302 104.416C99.5831 99.617 104.291 94.629 110.818 93.275C117.344 91.9211 123.218 94.7139 123.938 99.513C124.657 104.312 119.949 109.3 113.422 110.654Z",
    fill: "#25A6F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot13);
export default __webpack_public_path__ + "static/media/bot-13.91dc47a9f7e1a1a33c93a8f3084e29c1.svg";
export { ForwardRef as ReactComponent };